import './SingleDatePicker.scss'

import _ from 'lodash'
import React, { Component } from 'react'
import { SingleDatePicker, isInclusivelyAfterDay } from 'react-dates'
import { isEmbedded } from 'common/util/features'
import { format, parse, isValid } from 'date-fns'
import moment from 'moment'
import cx from 'classnames'

export class DatePicker extends Component {
  state = {
    date_picker_open: false,
  }

  nativeOnBlur = (event) => {
    const { onBlur } = this.props
    onBlur && onBlur()
    this.nativeHandleChange(_.get(event, ['target', 'value']))
  }

  nativeOnChange = (event) => {
    this.nativeHandleChange(_.get(event, ['target', 'value']))
  }

  nativeHandleChange = chosenDate => {
    if (!chosenDate) {
      return
    }
    try {
      if (isValid(parse(chosenDate))) {
        this.props.onChange(chosenDate)
      }
    } catch (e) {
      // no-op
    }
  }

  getOutsideRange = () => {
    const { pastDatesOnly, futureDatesOnly } = this.props

    if (pastDatesOnly) {
      return (day) => !isInclusivelyAfterDay(moment(), day)
    }

    if (futureDatesOnly) {
      return (day) => {
        return isInclusivelyAfterDay(moment(), day)
      }
    }

    return () => false
  }

  handleFocusChange = ({ focused }) => {
    const { onBlur } = this.props
    !focused && onBlur && onBlur()
    return this.setState({ date_picker_open: focused })
  }

  render() {
    const { label, onChange, value, orientation, disabled, errorMsg, useNative, pastDatesOnly, futureDatesOnly, manualClassName } = this.props
    const { date_picker_open } = this.state
    const nativePicker = isEmbedded() && useNative
    const pastDateMax = pastDatesOnly ? { max: format(new Date(), "YYYY-MM-DD") } : {}
    const futureDateMin = futureDatesOnly ? { min: format(new Date(), "YYYY-MM-DD") } : {}
    const className = cx(
      'NativeDateInput',
      manualClassName,
      {
        'incorrect-input': !!errorMsg,
      }
    )

    return (
      <div className={`OP_SingleDatePicker ${disabled ? 'OP_SingleDatePicker--disabled' : ''}`}>
        <label htmlFor="single-date-picker">{label}</label>
        {nativePicker ? (
          <input
            id="single-date-picker"
            ref={ref => this.datePickerRef = ref}
            className={className}
            type='date'
            value={value && format(parse(value), "YYYY-MM-DD")}
            onChange={this.nativeOnChange}
            onBlur={this.nativeOnBlur}
            {...pastDateMax}
            {...futureDateMin}
          />
        ) : (<SingleDatePicker
          id="single-date-picker"
          date={typeof value === "string" ? moment(value, "YYYY-MM-DD") : value}
          onDateChange={date => onChange(format(date, "YYYY-MM-DD"))}
          focused={date_picker_open}
          onFocusChange={this.handleFocusChange}
          withFullScreenPortal={true}
          orientation={orientation}
          disabled={disabled}
          isOutsideRange={this.getOutsideRange()}
        />)}
        <div className="OP_SingleDatePicker__error">
          {!!errorMsg && <span className="OP_SingleDatePicker__error--message"> <span className="fa fa-exclamation-circle"></span> &nbsp;{errorMsg}</span>}
        </div>
      </div>
    )
  }
}
